import React, { useEffect, useState } from 'react'
import '../../assets/css/modalinvitetoreg.css'


const ModalInviteToReg = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [rightOffset, setRightOffset] = useState(20)

  useEffect(() => {
    const isLoggedIn =
      window &&
      window.KENTEK_USER &&
      window.KENTEK_USER.isAuthorized === true

    if (isLoggedIn) return

    const alreadyClosed = sessionStorage.getItem('promo_popup_closed')
    if (!alreadyClosed) {
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    const calculateOffset = () => {
      const width = window.innerWidth
      const offset = width > 1400 ? (width - 1400) / 2 + 20 : 20
      setRightOffset(offset)
    }

    calculateOffset()
    window.addEventListener('resize', calculateOffset)
    return () => window.removeEventListener('resize', calculateOffset)
  }, [])

  const closePopup = () => {
    setIsVisible(false)
    sessionStorage.setItem('promo_popup_closed', '1')
  }

  if (!isVisible) return null

  return (
    <div className="modal-invite-wrapper" style={{ right: `${rightOffset}px` }}>
      <div className="modal-invite">
        <button className="modal-invite__close" onClick={closePopup}>×</button>
        <h3 className="modal-invite__title">Оформите доступ</h3>
        <p className="modal-invite__text">
          Только для юр.лиц. Для получения скидок зарегистрируйтесь.
        </p>
        <a
          href={`/login/register/?backurl=${encodeURIComponent(window.location.pathname + window.location.search)}`}
          className="modal-invite__button"
        >
          Зарегистрироваться
        </a>
        <div className="modal-invite__footer">
          Уже есть аккаунт?{' '}
          <a href={`/login/?backurl=${encodeURIComponent(window.location.pathname + window.location.search)}`}>
            Войти
          </a>
        </div>
      </div>
    </div>
  )
  
}


export default ModalInviteToReg
